export default __webpack_public_path__ + "static/media/R57SR54.6cad9d31.png";